import { useState, useEffect } from "react";

export default function ShapeBg({ position_bottom }) {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // Déclenche l'animation lorsque position_bottom change
    setIsAnimating(true);

    // Supprime l'animation après 1 seconde (durée de l'animation)
    const timeout = setTimeout(() => setIsAnimating(false), 1000);

    return () => clearTimeout(timeout);
  }, [position_bottom]);

  return (
    <div style={{ transitionDuration: '0.5s', bottom: `${position_bottom}vh`, position: 'fixed', width: "100%", height: "100vh", overflow: "hidden", pointerEvents: 'none' }}>
      {/* Image de fond animée une seule fois */}
      <img
        style={{
          position: "absolute",
          bottom: "16%",
          width: "100%",
          transformOrigin: 'bottom',
        }}
        className={isAnimating ? "scale-once" : ""}
        src="/assets/illustre-game.png"
        alt="road"
      />

      {/* SVG fixe */}
      <svg
        style={{
          position: "absolute",
          bottom: "-10%",
          width: "100%",
          height: "100%",
        }}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 393 728"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-340.732 0H-343V880H737V0H734.732C709.582 274.773 478.434 489.988 197 489.988C-84.4337 489.988 -315.582 274.773 -340.732 0Z"
          fill="#118A9B"
        />
      </svg>

      {/* Animation CSS */}
      <style>
        {`
          @keyframes scaleOnce {
            0% { transform: scaleY(1); }
            50% { transform: scaleY(1.2); }
            100% { transform: scaleY(1); }
          }

          .scale-once {
            animation: scaleOnce 0.8s ease-in-out;
          }
        `}
      </style>
    </div>
  );
}
